import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Link as RouterLink } from 'react-router-dom-v5-compat';
import { useTheme } from 'app/components/core/ThemeProvider';
import { Defaults } from 'app/lib/constants';
import { Icon, IconSize } from 'app/components/core/Icon';
import * as styles from './NavLink.css';

const cx = classnames.bind(styles);

export function NavLink({
    to,
    state = Defaults.OBJECT,
    className,
    disabled = false,
    children,
    title,
    external = false,
    ...props
}) {
    const { themeClassname } = useTheme();
    const classes = cx('base', themeClassname, className);

    if (disabled) {
        return (
            <span className={classes} title={title}>
                {children}
            </span>
        );
    }

    if (external) {
        return (
            <a href={to} rel="noreferrer" target="_blank" className={classes} title={title}>
                {children} <Icon size={IconSize.MINI} variant="expand" inline />
            </a>
        );
    }

    return (
        <RouterLink
            className={classes}
            to={to}
            state={{ internal: true, ...state }}
            title={title}
            {...props}>
            {children}
        </RouterLink>
    );
}

NavLink.propTypes = {
    to: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            pathname: PropTypes.string,
            search: PropTypes.string,
            hash: PropTypes.hash
        })
    ]).isRequired,
    state: PropTypes.shape({}),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    external: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
